import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import AdvisoryPriceDisplay from '@stubhub/react-advisory-price-display';
import {connect} from '@stubhub/react-store-provider';

import Dropdown from '../../components/react-dropdown-list';
import QuantityDisplay from '../../containers/react-build-your-order/components/react-quantity-display';
import ExpandIcon from '../icons/expand';

import controller from './controller';

import './index.scss';

const MobileQuantitySelector = ({enableQuantityPicker, toggleOnQtyPickClose, selectedQuantity}) => (
  <button
    className="RoyalBuildYourOrder__pickerBtn"
    onClick={() => toggleOnQtyPickClose()}
    disabled={!enableQuantityPicker}
    type="button"
  >
    <span className="RoyalBuildYourOrder__pickerBtn__dropdown">
      <span className="RoyalBuildYourOrder__pickerBtn__dropdown__left">
        <span className="RoyalBuildYourOrder__pickerBtn__dropdown__left__quantity">
          <FormattedMessage id="event-royal.react-build-your-order.quantity" defaultMessage="Quantity" />
        </span>
        <QuantityDisplay
          quantity={selectedQuantity}
          className="RoyalBuildYourOrder__pickerBtn__dropdown__left__ticket"
        />
        <span className="RoyalBuildYourOrder__pickerBtn__dropdown__left__ticketText">
          <FormattedMessage id="event-royal.react-build-your-order.tickets" defaultMessage="tickets" />
        </span>
      </span>
      <span className="RoyalBuildYourOrder__pickerBtn__dropdown__right">
        <span className="RoyalBuildYourOrder__pickerBtn__dropdown__right__icon">
          <ExpandIcon width="12px" height="7px" color="rgb(47, 52, 59)" />
        </span>
      </span>
    </span>
  </button>
);

MobileQuantitySelector.propTypes = {
  enableQuantityPicker: PropTypes.bool,
  toggleOnQtyPickClose: PropTypes.func.isRequired,
  selectedQuantity: PropTypes.number,
};

@connect(controller)
class TicketsQuantityPicker extends Component {
  render() {
    const {
      price = {},
      toggleOnQtyPickClose,
      mobile,
      enableQuantityPicker,
      selectedQuantity,
      splitVector = [],
      isPriceLoading,
    } = this.props;

    return (
      <div className="RoyalBuildYourOrder__price__container">
        <div className="RoyalBuildYourOrder__price">
          <div className="RoyalBuildYourOrder__price__header">
            <FormattedMessage id="event-royal.react-build-your-order.priceHeader" defaultMessage="You'll pay" />
          </div>
          <div className="RoyalBuildYourOrder__price__display--actual">
            <div className="RoyalBuildYourOrder__price__display--actual__amount">
              <AdvisoryPriceDisplay price={price.amount} currency={price.currency} isLoading={isPriceLoading} />
              <div className="RoyalBuildYourOrder__price__display--actual__amount__each">
                <FormattedMessage id="BuildYourOrder.each" defaultMessage="each" />
              </div>
            </div>
          </div>
        </div>
        {mobile ? (
          <MobileQuantitySelector
            enableQuantityPicker={enableQuantityPicker}
            toggleOnQtyPickClose={toggleOnQtyPickClose}
            selectedQuantity={selectedQuantity}
          />
        ) : (
          <Dropdown
            onSelection={toggleOnQtyPickClose}
            disabled={!enableQuantityPicker}
            byoQuantity={selectedQuantity}
            splitVector={splitVector}
          />
        )}
      </div>
    );
  }
}

TicketsQuantityPicker.propTypes = {
  price: PropTypes.object,
  toggleOnQtyPickClose: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  enableQuantityPicker: PropTypes.bool,
  selectedQuantity: PropTypes.number,
  splitVector: PropTypes.array,
  isPriceLoading: PropTypes.bool,
};

export default TicketsQuantityPicker;
